import { Box } from 'grommet'
import React from 'react'

const ArchiveCanvas = (props:any) => {
  return(
    <Box
      pad="1px"
      background="rgb(0,0,0,0.1)"
      round="small"
      elevation="large"
      alignSelf="center"
      height="full"
      width="95%"
      {...props}
    >
    </Box>
  )
}

export default ArchiveCanvas;